<app-cover-design-asset
  [gallery]="gallery()"
  [theme]="theme()"
  [previewAsset]="previewAsset()"
  [noAsset]="noAsset()"
></app-cover-design-asset>
<div [style.backgroundColor]="theme().layout_page.background_color" [class.animated]="animated()"></div>
